export default __webpack_public_path__ + "static/media/3.59e0bbce.webp";